import React, {memo, useCallback, useMemo, useState} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {useSelector} from "react-redux"
import {useLocalization} from "../../../../hooks/localization"
import {useBackground} from "../../../../hooks/background-class"
import {useHistory, useParams} from "react-router-dom"
import iconSave from "../../../../assets/images/icons/media/save.png"
import iconCancel from "../../../../assets/images/icons/media/cancel.png"
import iconPlus from "../../../../assets/images/icons/controls/plus.png"
import iconTrash from "../../../../assets/images/icons/trash.png"
import {onClickHandler} from "../../../../utils/onclick"
import {UserModel} from "../../../../types/control"
import {useMessage} from "../../../../hooks/message"
import {useRPC} from "../../../../hooks/rpc"
import "./index.scss"

let tlr = "-->"
export const AuthorizationGroupAddUser = memo(function AuthorizationGroupAddUser() {
    const [, , backgroundStyle] = useBackground()
    const params = useParams<{id: string}>()
    const {t} = useLocalization()
    const [rpc] = useRPC()
    const {failure, success} = useMessage()
    const history = useHistory()
    const authorityList = useSelector(state => state.control.authorityGroupList)
    const selectedAuthority = authorityList.find(r => r.id === params.id)
    const userList = useSelector(state => state.control.userList).filter(r => r.username !== "" && r.role === 'user')

    const addedUserList = useMemo(() => {
        const selectedIds = selectedAuthority?.user_id_list?.map(r => r)
        const manupuledList = userList?.filter(r => selectedIds?.includes(r?.id))
        return manupuledList
    }, [userList, selectedAuthority])

    const allUserList = useMemo(() => {
        const selectedIds = selectedAuthority?.user_id_list?.map(r => r)
        const manupuledList = userList
            ?.filter(r => (r?.authority_group_id === "" || r?.authority_group_id === params?.id) && !selectedIds?.includes(r?.id))
        return manupuledList
    }, [userList, selectedAuthority, params.id])

    const [filteredUserList, setFilteredUserList] = useState(allUserList || [])

    const [actionList, setActionList] = useState(addedUserList || [])
    const onClickAddUser = useCallback((selected: UserModel) => {
        setActionList(p => [...p, selected])
        setFilteredUserList(p => p.filter(r => r.id !== selected.id))
    }, [])

    const onClickRemoveUser = useCallback(
        (id: string) => {
            setActionList(p => p.filter(i => i.id !== id))
            setFilteredUserList([...filteredUserList, actionList.find(v => v.id === id)])
        },
        [filteredUserList, actionList]
    )

    const onClickBack = useCallback(() => history.push("/settings/authority"), [history])
    const onClickSave = useCallback(() => {
        return rpc
            .updateAuthorityGroup({...selectedAuthority, user_id_list: actionList.map(r => r.id)})
            .then(() => {
                success(t("authority.user_added"))
                onClickBack()
            })
            .catch(failure)
    }, [t, onClickBack, failure, success, rpc, selectedAuthority, actionList])
    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <div className="auth-full-container" style={{backgroundImage: backgroundStyle?.backgroundImage}}>
                <div className="auth-add-user-container">
                    <div className="auth-add-user-top-bar">
                        <span>
                            {t("authority.add_user")} &nbsp; {tlr} &nbsp; {selectedAuthority.name}
                        </span>
                        <span>
                            <img src={iconCancel} alt="" {...onClickHandler(onClickBack)} />
                            <img src={iconSave} alt="" {...onClickHandler(onClickSave)} />
                        </span>
                    </div>
                    <div className="auth-add-user-action-container">
                        <div className="auth-add-user-action">
                            <div className="auth-add-user-field">
                                {filteredUserList.map(r => (
                                    <div className="auth-add-user-row" key={r.id}>
                                        <span>{r.username}</span>
                                        <img src={iconPlus} alt="" {...onClickHandler(() => onClickAddUser(r))} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="auth-add-user-action">
                            <div className="auth-add-user-field">
                                {actionList.map(r => (
                                    <div className="auth-add-user-row" key={r.id}>
                                        <span>{r.username}</span>
                                        <img
                                            src={iconTrash}
                                            alt=""
                                            style={{width: "20px", padding: "0"}}
                                            {...onClickHandler(() => onClickRemoveUser(r.id))}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PasswordContainer>
    )
})
